import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

function BarsChart(props) {
    const { categories, refLabel, candLabel, refColor = "#a5a5a5", candColor = "#0b1f82", format } = props
    const canvasRef = useRef(null)
    const chartRef = useRef(null)

    const categoriesSignature = JSON.stringify(categories)

    useEffect(() => {
        if (chartRef.current) chartRef.current.destroy()
        const canvasContext = canvasRef.current.getContext("2d", { willReadFrequently: true })
        chartRef.current = new Chart(canvasContext, {
            type: "bar",
            data: {
                labels: categories.map(category => category.label),
                datasets: [
                    {
                        label: refLabel,
                        data: categories.map(category => category.ref),
                        backgroundColor: refColor,
                        borderRadius: 3,
                        categoryPercentage: 0.6,
                        barPercentage: 0.9
                    },
                    {
                        label: candLabel,
                        data: categories.map(category => category.cand),
                        backgroundColor: candColor,
                        borderRadius: 3,
                        categoryPercentage: 0.6,
                        barPercentage: 0.9
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: format ? {
                        callbacks: { label: (item) => item.dataset.label + ": " + format(item.parsed.y) }
                    } : {}
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: format ? { callback: (value) => format(value) } : {}
                    }
                }
            }
        })
        return () => {
            if (chartRef.current) chartRef.current.destroy()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoriesSignature, refLabel, candLabel, refColor, candColor])

    return (
        <div style={{ height: "260px" }}>
            <canvas ref={canvasRef} />
        </div>
    )
}

export default BarsChart
